"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _noop3 = _interopRequireDefault(require("lodash-es/noop"));

var _get3 = _interopRequireDefault(require("lodash-es/get"));

var _debounce3 = _interopRequireDefault(require("lodash-es/debounce"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactContext2 = _interopRequireDefault(require("create-react-context"));

var _styles = require("./_styles");

var _accordionItem = _interopRequireDefault(require("./_accordionItem.js"));

var _context = require("../../context");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _createReactContext = (0, _createReactContext2["default"])(),
    Provider = _createReactContext.Provider,
    Consumer = _createReactContext.Consumer;

var AccordionItemConsumer = function AccordionItemConsumer(parentProps) {
  return _react["default"].createElement(Consumer, null, function (props) {
    return _react["default"].createElement(_accordionItem["default"], _extends({}, parentProps, props));
  });
};

AccordionItemConsumer.displayName = 'AccordionItemConsumer';

var Accordion =
/*#__PURE__*/
function (_Component) {
  _inherits(Accordion, _Component);

  function Accordion(props) {
    var _this;

    _classCallCheck(this, Accordion);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Accordion).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onClick", (0, _debounce3["default"])(function (value) {
      var active = _this.state.active;
      var _this$props = _this.props,
          behaviour = _this$props.behaviour,
          onToggle = _this$props.onToggle;

      if (behaviour === 'radio') {
        active = active[0] === value ? [] : [value];
      } else {
        var isActive = active.indexOf(value) > -1;
        active = isActive ? active.filter(function (val) {
          return val !== value;
        }) : [].concat(_toConsumableArray(active), [value]);
      }

      _this.setState(function () {
        return {
          active: active
        };
      }, function () {
        return onToggle(active);
      });
    }, 200));

    _defineProperty(_assertThisInitialized(_this), "getInitialState", function () {
      var _this$props2 = _this.props,
          initialOpen = _this$props2.initialOpen,
          behaviour = _this$props2.behaviour,
          expandAll = _this$props2.expandAll,
          children = _this$props2.children;

      if (behaviour === 'radio') {
        return initialOpen.length > 1 ? initialOpen.slice(0, 1) : initialOpen;
      }

      return expandAll ? _react["default"].Children.map(children, function (child) {
        return (0, _get3["default"])(child, 'props.value', null);
      }).filter(function (truthy) {
        return truthy;
      }) : initialOpen;
    });

    var _active = _this.getInitialState();

    _this.state = {
      active: _active
    };
    return _this;
  }

  _createClass(Accordion, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          bordered = _this$props3.bordered;
      var activeIndices = this.state.active;
      return _react["default"].createElement(Provider, {
        value: {
          onClick: this.onClick,
          activeIndices: activeIndices,
          bordered: bordered
        }
      }, _react["default"].createElement(Accordion.Element, null, children));
    }
  }]);

  return Accordion;
}(_react.Component);

Accordion.Element = _styles.AccordionElement;
Accordion.Item = (0, _context.withVersion)(AccordionItemConsumer);
Accordion.propTypes = {
  /** initial panels to be expanded. NOTE: if bahaviour is radio
   * only the first value will be expanded */
  initialOpen: _propTypes["default"].arrayOf(_propTypes["default"].number),

  /** Primary content. */
  children: _propTypes["default"].node,

  /** callback called when accordion opens or closes */
  onToggle: _propTypes["default"].func,

  /** behave as a radio and open one at a time or as checkbox and open multiple */
  behaviour: _propTypes["default"].oneOf(['radio', 'checkbox']),

  /** expand all the accordions with this one flag. Note: initialOpen array will be discarded*/
  expandAll: _propTypes["default"].bool,

  /** bordered or not */
  bordered: _propTypes["default"].bool
};
Accordion.defaultProps = {
  onToggle: _noop3["default"],
  initialOpen: [],
  behaviour: 'radio',
  expandAll: false,
  bordered: true
};
Accordion.displayName = 'Accordion';

var _default = (0, _context.withVersion)(Accordion);

exports["default"] = _default;